import { Alert } from '@dittolive/anvil'

import type { Announcement } from '.'
import { acknowledgedAlert } from './utils'

export type AnnouncementAlertProps = {
  announcement: Announcement
  onClose?: () => void
}

export default function AnnouncementAlert({
  announcement,
  onClose,
}: AnnouncementAlertProps) {
  const getVariant = () => {
    const { severity } = announcement
    if (severity === 'WARNING') {
      return 'warning'
    } else if (severity === 'DANGER') {
      return 'danger'
    }

    return 'info'
  }

  const renderDetails = () => {
    const { details } = announcement

    if (!details || !details.length) {
      return null
    }

    return details.split('\n').map((paragraph, idx) => (
      <p
        data-testid="announcementDetailsParagraph"
        key={`announcement-details-${idx}`}
      >
        {paragraph}
      </p>
    ))
  }

  const handleClose = () => {
    acknowledgedAlert(announcement.id)
    onClose?.()
  }

  const variant = getVariant()

  return (
    <Alert
      variant={variant}
      autoDismiss={false}
      onClose={handleClose}
      data-testid="announcementAlert"
    >
      <Alert.Title>{announcement.title}</Alert.Title>
      <Alert.Body className="flex flex-col space-y-2">
        <p>{announcement.summary}</p>
        {renderDetails()}
      </Alert.Body>
    </Alert>
  )
}
